var map = {
	"./2d-color-picker/addon.json": "./src/addons/addons/2d-color-picker/addon.json",
	"./bitmap-copy/addon.json": "./src/addons/addons/bitmap-copy/addon.json",
	"./block-palette-icons/addon.json": "./src/addons/addons/block-palette-icons/addon.json",
	"./block-switching/addon.json": "./src/addons/addons/block-switching/addon.json",
	"./blocks2image/addon.json": "./src/addons/addons/blocks2image/addon.json",
	"./cat-blocks/addon.json": "./src/addons/addons/cat-blocks/addon.json",
	"./clones/addon.json": "./src/addons/addons/clones/addon.json",
	"./color-picker/addon.json": "./src/addons/addons/color-picker/addon.json",
	"./custom-block-shape/addon.json": "./src/addons/addons/custom-block-shape/addon.json",
	"./custom-zoom/addon.json": "./src/addons/addons/custom-zoom/addon.json",
	"./data-category-tweaks-v2/addon.json": "./src/addons/addons/data-category-tweaks-v2/addon.json",
	"./debugger/addon.json": "./src/addons/addons/debugger/addon.json",
	"./drag-drop/addon.json": "./src/addons/addons/drag-drop/addon.json",
	"./editor-colored-context-menus/addon.json": "./src/addons/addons/editor-colored-context-menus/addon.json",
	"./editor-devtools/addon.json": "./src/addons/addons/editor-devtools/addon.json",
	"./editor-searchable-dropdowns/addon.json": "./src/addons/addons/editor-searchable-dropdowns/addon.json",
	"./editor-sounds/addon.json": "./src/addons/addons/editor-sounds/addon.json",
	"./editor-stage-left/addon.json": "./src/addons/addons/editor-stage-left/addon.json",
	"./editor-theme3/addon.json": "./src/addons/addons/editor-theme3/addon.json",
	"./folders/addon.json": "./src/addons/addons/folders/addon.json",
	"./gamepad/addon.json": "./src/addons/addons/gamepad/addon.json",
	"./hide-flyout/addon.json": "./src/addons/addons/hide-flyout/addon.json",
	"./initialise-sprite-position/addon.json": "./src/addons/addons/initialise-sprite-position/addon.json",
	"./load-extensions/addon.json": "./src/addons/addons/load-extensions/addon.json",
	"./mediarecorder/addon.json": "./src/addons/addons/mediarecorder/addon.json",
	"./mouse-pos/addon.json": "./src/addons/addons/mouse-pos/addon.json",
	"./mute-project/addon.json": "./src/addons/addons/mute-project/addon.json",
	"./onion-skinning/addon.json": "./src/addons/addons/onion-skinning/addon.json",
	"./pause/addon.json": "./src/addons/addons/pause/addon.json",
	"./remove-curved-stage-border/addon.json": "./src/addons/addons/remove-curved-stage-border/addon.json",
	"./remove-sprite-confirm/addon.json": "./src/addons/addons/remove-sprite-confirm/addon.json",
	"./transparent-orphans/addon.json": "./src/addons/addons/transparent-orphans/addon.json",
	"./tw-interface-customization/addon.json": "./src/addons/addons/tw-interface-customization/addon.json",
	"./tw-project-info/addon.json": "./src/addons/addons/tw-project-info/addon.json",
	"./variable-manager/addon.json": "./src/addons/addons/variable-manager/addon.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/addons/addons sync recursive ^\\.\\/.*\\/addon\\.json$";